import React from 'react';
import { Link } from 'react-router-dom';
import './FeedPage.css';

const FeedPage = ({ posts, onLike }) => {
  const handleLike = (postId, e) => {
    e.preventDefault();
    e.stopPropagation();
    onLike(postId);
  };

  if (posts.length === 0) {
    return (
      <div className="feed-page">
        <div className="no-posts">
          <h3>No posts yet</h3>
          <p>Posts will appear here once they are added.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="feed-page">
      <div className="posts-grid">
        {posts.map(post => (
          <div key={post._id} className="post-card">
            {/* ADD TITLE SECTION */}
            <div className="post-title-section">
              <h3 className="post-title">{post.title}</h3>
            </div>
            
            <div className="post-media">
              {post.type === 'video' ? (
                <div className="video-container">
                  <video 
                    className="post-video"
                    controls
                    preload="metadata"
                  >
                    <source src={post.imageUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div className="video-overlay">
                    <div className="play-button">▶️</div>
                  </div>
                </div>
              ) : (
                <img 
                  src={post.imageUrl} 
                  alt={post.title}
                  className="post-image"
                />
              )}
            </div>
            
            <div className="post-actions">
              <button 
                className="like-btn"
                onClick={(e) => handleLike(post._id, e)}
              >
                🤍 {post.likes.toLocaleString()}
              </button>
              <button className="share-btn">🔗 Share</button>
              <Link to={`/post/${post._id}`} className="details-btn">
                📖 More Details
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeedPage;